import React, {Component} from 'react';
import './ProfilePage.css';
import Review from './Review';
import actions, {retrieveProfile} from './profile.actions';
import {connect} from 'react-redux';
import {DocumentTitle, FancyButton, Spinner} from '../widgets';
import ProfileSidePane from './ProfileSidePane';
import {CommunityCard} from '../community';
import {uiActions} from '../chrome';
import reviewActions from './reviews.actions';
import editingProfileActions from './editingProfile.actions';
import ProfileImages from './ProfileImages';
import {checkOnInit, checkOnPropChanges} from './profilePathCheck';
import BioHelper from './BioHelper';
import CommunitySearchDropdown from '../search/CommunitySearchDropdown';
import Icon from '../widgets/Icon';
import {sessionUserIsIdentifiable} from '../user/session.selectors';

class ProfilePage extends Component {
	constructor(props) {
		super(props);

		checkOnInit(props);
	}

	componentWillReceiveProps(nextProps) {
		checkOnPropChanges(nextProps, this.props);
	}

	render() {
		if (!this.props.profile || !this.props.profile.user) {
			return (
				<DocumentTitle title="B2Me">
					<main className="ProfilePage">
						<Spinner />
					</main>
				</DocumentTitle>
			);
		}

		const {
			reviews,
			profile: {
				user: {uuid: userUuid, firstname},
				profile: {brief, about, avatarImage, uniqueName},
				communities,
				subscriptionLevel
			},
			sessionProvider,
			editContacts,
			editable,
			isAdmin,
			writeReview,
			editReview,
			newCommunity,
			sessionUserIsIdentifiable
		} = this.props;

		const isViewingOwn =
			userUuid === (sessionProvider && sessionProvider.user && sessionProvider.user.uuid);

		const userReview =
			reviews &&
			sessionProvider &&
			sessionProvider.provider &&
			reviews.filter(r => r.reviewer.uuid === sessionProvider.provider.uuid)[0];

		return (
			<DocumentTitle
				title={`${this.props.profile.user.firstname} ${this.props.profile.user.lastname} - B2Me`}>
				<main className={`ProfilePage ${editable ? 'enabled' : 'disabled'}`}>
					<ProfileSidePane
						login={this.props.login}
						profile={this.props.profile}
						editContacts={editContacts}
						editable={editable}
						isViewingOwn={isViewingOwn}
						isLoggedIn={!!(sessionProvider && sessionProvider.user)}
						isAdmin={!!(sessionProvider && sessionProvider.user && sessionProvider.user.admin)}
					/>

					<section className="ProfilePage-details">
						{(firstname || brief) && subscriptionLevel !== 'none' ? (
							<article className="ProfilePage-profile-summary">
								<div className="ProfilePage-brief">
									<p>{brief || `${firstname}'s profile`}</p>
								</div>
							</article>
						) : (
							undefined
						)}

						{subscriptionLevel !== 'none' ? <ProfileImages /> : undefined}

						{about && subscriptionLevel !== 'none' && (
							<article className="ProfilePage-profile-about">
								{firstname && (
									<div className="ProfilePage-header">
										<h2>About {firstname}</h2>
									</div>
								)}
								<div className="ProfilePage-prose">{about}</div>
							</article>
						)}

						{communities && communities.length ? (
							<article className="ProfilePage-profile-affiliations">
								<div className="ProfilePage-header">
									<h2 ref={el => (this.elAffiliations = el)}>Affiliations</h2>
								</div>
								{/* {isViewingOwn && (
									<div className="ProfilePage-profile-affiliations-actions">
										<BioHelper stepKey="community" center={false} subscriptionLevel={subscriptionLevel}/>
										<CommunitySearchDropdown
											scrollIntoViewElement={() => this.elAffiliations}
										/>
										<span className="ProfilePage-profile-spacer">or</span>
										<FancyButton onClick={newCommunity}>Create a community</FancyButton>
									</div>
								)} */}
								<ol>
									{communities.map(community => (
										<CommunityCard key={community.uuid} community={community} />
									))}
								</ol>
							</article>
						) : (
							undefined
						)}

						{subscriptionLevel !== 'none' ? (
							<article className="ProfilePage-profile-reviews">
								<div className="ProfilePage-header">
									<h2>
										<span>Reviews</span>
										{sessionProvider &&
											sessionProvider.user &&
											firstname &&
											!isViewingOwn &&
											(!!userReview ? (
												<button
													className="ProfilePage-review"
													onClick={() => editReview(userReview)}
													disabled={!sessionUserIsIdentifiable}>
													<span className="icon icon-rate_review" />
													<span>Edit your review of {firstname}'s work</span>
												</button>
											) : (
												<button
													className="ProfilePage-review"
													onClick={writeReview}
													disabled={!sessionUserIsIdentifiable}>
													<span className="icon icon-rate_review" />
													<span>Review {firstname}'s work</span>
												</button>
											))}
									</h2>
								</div>
								{/*#308: Prohibit a user adding someone to their collections or giving a review if their first or last name is not filled in.*/}
								{sessionProvider &&
								sessionProvider.user &&
								firstname &&
								!isViewingOwn &&
								!sessionUserIsIdentifiable ? (
									<div className="ProfilePage-message">
										<Icon name="warning" />
										Note: you must have filled in your details before adding a review for another
										person
									</div>
								) : (
									undefined
								)}
								{(!reviews || !reviews.length) && (
									<div className="ProfilePage-message">
										This provider does not yet have any reviews.
									</div>
								)}
								{reviews && !!reviews.length && (
									<ul>
										{reviews.map(review => (
											<Review key={review.reviewer.uuid} review={review} />
										))}
									</ul>
								)}
							</article>
						) : (
							undefined
						)}
					</section>
				</main>
			</DocumentTitle>
		);
	}
}

const ConnectedProfilePage = connect(
	({profile, reviews, session}) => ({
		profile,
		reviews: reviews && reviews.items,
		sessionProvider: session && session.current,
		// ISSUE: this is derived state. It doesn't really belong in mapStateToProps
		editable:
			session.current &&
			session.current.user &&
			profile &&
			(session.current.user.admin || session.current.provider.uuid === profile.uuid),
		sessionUserIsIdentifiable: sessionUserIsIdentifiable({session})
	}),
	dispatch => ({
		login: () => dispatch(uiActions.uiModal('login')),
		retrieveProfile: uniqueName => dispatch(retrieveProfile(uniqueName)),
		editContacts: () => {
			dispatch(actions.profileEditContacts());
			dispatch(uiActions.uiModal('profile-edit-contacts'));
		},
		writeReview: () => {
			dispatch(reviewActions.reviewsNewOpen());
			dispatch(uiActions.uiModal('profile-write-review'));
		},
		editReview: ({rating, communication, quality, affordability, trust, content}) => {
			dispatch(
				reviewActions.reviewsEditOpen({
					rating,
					communication,
					quality,
					affordability,
					trust,
					content
				})
			);
			dispatch(uiActions.uiModal('profile-write-review'));
		},
		newCommunity: () => {
			dispatch(editingProfileActions.initNewCommunity());
			dispatch(uiActions.uiModal('profile-edit-details'));
		}
	})
)(ProfilePage);

export default ConnectedProfilePage;



// WEBPACK FOOTER //
// ./src/profile/ProfilePage.js